import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = { class: "text-dark mb-3" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, [
  /*#__PURE__*/_createTextVNode(" Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-normal" }, "*")
], -1)
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "fv-plugins-message-container" }
const _hoisted_9 = { class: "fv-help-block" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "indicator-label" }
const _hoisted_12 = {
  key: 1,
  class: "alert alert-primary d-flex align-items-center p-5 mb-10"
}
const _hoisted_13 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4" }
const _hoisted_14 = { class: "d-flex flex-column" }
const _hoisted_15 = { class: "mb-1 text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("recoverPassword")), 1)
    ]),
    (!this.emailSent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "email",
              class: "form-control form-control-solid",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              autocomplete: "off",
              placeholder: _ctx.$t('emailNote')
            }, null, 8, _hoisted_7), [
              [_vModelText, _ctx.email]
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.emailError ? _ctx.$t(_ctx.emailError) : ""), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.recoverPassword())),
              class: "btn btn-lg btn-primary w-100 mb-5"
            }, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("recoverPassword")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (this.emailSent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen048.svg" })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h4", _hoisted_15, _toDisplayString(_ctx.$t("emailSent")), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("emailSentMessage")), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}